import React from 'react'
import DesignDetail from '../components/Design-detail';
import Designdata from '../components/Design-data';
import LeadDesign from '../components/Lead-design';
import usePageMeta from '../hooks/usePageMeta';
export default function Design() {
    usePageMeta('Professional Web Design & UI/UX Services | Spinnennetz', 'Transform your brand with our innovative web design services. Spinnennetz creates stunning, user-centric designs that engage visitors and boost your conversions.', '/design', {"@context":"https://schema.org","@type":"Service","name":"Professional Web Design","provider":{"@type":"Organization","name":"Spinnennetz"}});
    return (
        <>
            <DesignDetail/>
            <Designdata/>
            <LeadDesign/>
        </>
    )
}
